import React, { useState } from "react";

import {  Dialog, DialogTitle, DialogContent, DialogActions, Button,  Chip, Box, Alert } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import CloseIcon from '@mui/icons-material/Close';

import { FileDrop } from 'react-file-drop';

import ImportIcon from '@mui/icons-material/Upload';

import useMediaQuery from '@mui/material/useMediaQuery';
import Information from "../../Crm/TabButtons/Information";


export default function ResponsiveImportButton(
  { 
    className,
    loading,
    isDisabled,
    onClickFn,
    shouldRenderHiddenInput,
    onChangeFn,
    is_financial_market_company,
    dialogTitle = "Importação em massa de contatos",
    informationType = "contacts" 
  }) {

  const isSmallScreen = useMediaQuery('(max-width: 60rem)');

  const [showDialog, setShowDialog] = useState(false);
  const [file, setFile] = useState(null);


  return (
    <>
      <>
        <LoadingButton
          className={className}
          variant="contained"
          component="label"
          color="success"
          loading={loading}
          loadingPosition="start"
          disabled={isDisabled}
          onClick={(...params) => {
            onClickFn(...params);
            setShowDialog(true);
          }}
        >
          Importar em massa
        </LoadingButton>

        {showDialog && <Dialog open={true} onClose={() => {
          setShowDialog(false);
        }}
          BackdropClick={false}
          fullWidth
          maxWidth='md'
          disableEnforceFocus>
          <DialogTitle size="small">{dialogTitle}</DialogTitle>
          <DialogContent>
            <>  <Box sx={{display: 'flex', gap:'.5rem'}}>
            <Alert severity="info">
              Seu arquivo deve ser .csv, .xls ou .xlsx. Em arquivos CSV, os campos devem ser separados por vírgula (,) ou ponto e vírgula (;).
            </Alert>
            </Box>
              <div className="file-drop-container" style={{ marginTop: "1rem" }}>
                <FileDrop
                  onDrop={(files, event) => { setFile(files[0]); event.target.value = null }}
                >
                  {file ?
                    <Chip label={file.name} onDelete={() => { setFile(null) }} /> :
                    <span>Arraste e solte para inserir o anexo.
                    </span>
                  }
                  <span>ou</span>
                  <LoadingButton
                    variant="contained"
                    color="primary"
                    component="label"
                    loading={false}
                    loadingPosition="start"
                    startIcon={<ImportIcon />}
                    disabled={false}
                    onClick={() => { }}
                  >
                    Selecione
                    <input
                      hidden
                      accept=".csv,.CSV,.xls,.xlsx"
                      type="file"
                      onChange={(e) => { setFile(e.target.files[0]); e.target.value = null }}
                    />
                  </LoadingButton>
                </FileDrop>
              </div>
            </>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setShowDialog(false) }}>Cancelar</Button>
            <Button
              disabled={!file}
              onClick={() => {
                onChangeFn(file);
                setShowDialog(false);
              }}
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        }
        <Information
          is_financial_market_company={is_financial_market_company}
          informationType={informationType}
        />
      </>
    </>
  )
}
